import { computed } from "vue";
import { u as unwrapEl } from "../utils/unwrapEl-4d79d250.mjs";
const useHTMLElementSelector = (key) => {
  return computed(() => {
    if (typeof (key == null ? void 0 : key.value) === "string") {
      return document.querySelector(key.value);
    }
    return unwrapEl(key == null ? void 0 : key.value);
  });
};
export {
  useHTMLElementSelector as u
};
//# sourceMappingURL=useHTMLElementSelector-378861e4.mjs.map
